import { ModalWindow } from '@tblabs/truffle';
import { Table } from '@tblabs/truffle/Controls/TableBuilder/Table';
import { Translations } from '../Translations/Translations';
import { PrimaryButton } from '../Components/General/Buttons/PrimaryButton';
import { Led } from '../Components/Led/Led';
import { BlinkMode } from '../Components/Led/BlinkMode';


export class StatusIconInfoWindow extends ModalWindow
{
    private greenFlashingLed = new Led().Blink(Led.Green, 600, BlinkMode.LightUp);
    private redBlinkingLed = new Led().Blink(Led.Red, 600, BlinkMode.Both);

    constructor(_lang: Translations)
    {
        super(_lang.StatusLamp, true, false, true);

        this.AddContent(
            new Table([], [
                [new Led(Led.White), _lang.CameraOffline],
                [new Led(Led.Green), _lang.CameraOnline],
                [this.greenFlashingLed, _lang.PictureReceived],
                [new Led(Led.Blue), _lang.CameraHalted],
                [new Led(Led.Yellow).LightUp(Led.Yellow, 0), _lang.InputActive],
                [new Led(Led.Orange), _lang.ProblemWithCamera],
                [this.redBlinkingLed, _lang.ProblemWithServer],
            ]).Class("small-table")
        );
        this.AddToFooter(
            new PrimaryButton(_lang.Close).OnClick(() => this.CloseWindow())
        );

        this.OpenWindow();
    }

    protected async OnRemove(): Promise<void>
    {
        this.greenFlashingLed.Destroy();
        this.redBlinkingLed.Destroy();
    }
}
